import axios from 'axios';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api/customer';

const customerApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

customerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('customer_token');
      localStorage.removeItem('customer_user');
      window.location.href = '/order/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const googleSession = (sessionId) =>
  customerApi.post('/auth/google-session', { session_id: sessionId });

export const getMe = () =>
  customerApi.get('/auth/me');

export const setPhoneNumber = (phone) =>
  customerApi.put('/auth/phone', { phone });

export const getProfile = () =>
  customerApi.get('/auth/profile');

export const getMyWallet = () =>
  customerApi.get('/auth/wallet');

export const getWalletDashboard = () =>
  customerApi.get('/wallet');

export const updateProfile = (data) =>
  customerApi.put('/auth/profile', data);

// Addresses
export const getAddresses = () =>
  customerApi.get('/auth/addresses');

export const addAddress = (data) =>
  customerApi.post('/auth/addresses', data);

export const deleteAddress = (addressId) =>
  customerApi.delete(`/auth/addresses/${addressId}`);

export const updateAddressLocation = (addressId, lat, lng) =>
  customerApi.put(`/auth/addresses/${addressId}/location`, { lat, lng });

// Stores (public)
export const getStores = () =>
  customerApi.get('/stores');

export const getStoreDetail = (storeId) =>
  customerApi.get(`/stores/${storeId}`);

// Menu (public)
export const getStoreMenu = (storeId) =>
  customerApi.get(`/menu/${storeId}`);

export const getMenuCategories = (storeId) =>
  customerApi.get(`/menu/${storeId}/categories`);

// Orders
export const placeOrder = (data) =>
  customerApi.post('/orders', data);

export const getMyOrders = (limit = 20) =>
  customerApi.get(`/orders?limit=${limit}`);

export const getOrderDetail = (orderId) =>
  customerApi.get(`/orders/${orderId}`);

export const cancelOrder = (orderId, refundMethod = 'original') =>
  customerApi.put(`/orders/${orderId}/cancel`, { refund_method: refundMethod });

export const requestCancellation = (orderId, reason, photoUrls, refundMethod = 'original') =>
  customerApi.post(`/orders/${orderId}/request-cancellation`, {
    reason, photo_urls: photoUrls, refund_method: refundMethod,
  });

export const trackOrder = (orderId) =>
  customerApi.get(`/track/${orderId}`);

// Payments
export const getPaymentConfig = () =>
  customerApi.get('/payments/config');

export const createPaymentOrder = (orderId, amount) =>
  customerApi.post('/payments/create-order', { order_id: orderId, amount });

export const verifyPayment = (data) =>
  customerApi.post('/payments/verify', data);

export default customerApi;
